import React from 'react';
import CardSelect from "../components/CardSelect";
import ListSelect from "../components/ListSelect";
import {Button, SegmentGroup} from "semantic-ui-react";
import {AccountItem} from "../view/CommonPage";
import {FormattedHTMLMessage as MSGS} from "react-intl";
import {getSystemType, SystemType} from "../Utils";

interface IProperties {
    single?: boolean
    items: Array<AccountItem>
    setSelectedAccounts: (selected: Set<AccountItem>) => void
}

interface IState {
    selectedItems: Set<AccountItem>
    disabled: boolean
}

/**
 * Страница выбора счетов. Может быть выбран один или несколько счетов, в зависимости от параметра.
 */
export default class AccountSelect extends React.Component<IProperties, IState> {

    state: IState = {
        selectedItems: new Set<AccountItem>(),
        disabled: true
    };

    updateItems = (checked : boolean, item: AccountItem) =>
    {
        let items: Set<AccountItem> = this.state.selectedItems;
        
        if (this.props.single)
            items.clear();

        if (checked)
            items.add(item);
        else
            items.delete(item);

        this.props.setSelectedAccounts(items);
        this.setState({selectedItems : items, disabled : items.size === 0});
    };

    render()
    {
        let text = (this.props.single) ? <MSGS id="select_accounts_single"/> : <MSGS id="select_accounts_multiple"/>;
        let body;
        if (getSystemType() === SystemType.BBK)
        {
            body = <SegmentGroup>
                {
                    this.props.items.map((item, count) =>
                    {
                        let selected = this.state.selectedItems.has(item);
                        return (
                            <ListSelect key={count} account={item} selected={selected} onClick={(checked) => this.updateItems(checked, item)}/>
                        )
                    })
                }
            </SegmentGroup>
        }
        else 
        {
            body = this.props.items.map((item, count) =>
            {
                let selected = this.state.selectedItems.has(item);
                return (
                    <CardSelect key={count} account={item} selected={selected} onClick={(checked) =>this.updateItems(checked, item)}/>
                )
            });
        }

        return (
            <div>
                <div className={"app-text"}>{text}</div>
                {body}
                <div className={"page-footer"}>
                    <Button type="submit" disabled={this.state.disabled} primary fluid content={<MSGS id="select_accounts_button"/>}/>
                </div>
            </div>
        )
    }
}